import { render, staticRenderFns } from "./yjjy.vue?vue&type=template&id=3ca52f9a&scoped=true&"
import script from "./yjjy.vue?vue&type=script&lang=js&"
export * from "./yjjy.vue?vue&type=script&lang=js&"
import style0 from "./yjjy.vue?vue&type=style&index=0&id=3ca52f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca52f9a",
  null
  
)

export default component.exports